/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useRef, useEffect } from "react";
import { cn } from "tailwind-variants";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import ArtworkError from "./ArtworkError.vue";
import { useDtfStore } from "./store";
import { useSpanglesStore } from "./spangles-module";
import "./DtfAddToCart.scss";

export default function DtfAddToCart({ ...restProps }) {
  const store = useDtfStore();
  const spanglesStore = useSpanglesStore();
  const submittedOnMousedown = useRef(false);

  // @ts-expect-error TS(6133): 'artworks' is declared but its value is never read... Remove this comment to see the full error message
  function artworks() {
    // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
    return store.artworks;
  }

  // @ts-expect-error TS(6133): 'modalArtworks' is declared but its value is never... Remove this comment to see the full error message
  function modalArtworks() {
    // @ts-expect-error TS(4111): Property 'modalArtworks' comes from an index signa... Remove this comment to see the full error message
    return store.modalArtworks;
  }

  function isReadyForOrder() {
    // @ts-expect-error TS(4111): Property 'isReadyForOrder' comes from an index sig... Remove this comment to see the full error message
    return store.isReadyForOrder;
  }

  // @ts-expect-error TS(6133): 'currentStore' is declared but its value is never ... Remove this comment to see the full error message
  function currentStore() {
    // @ts-expect-error TS(4111): Property 'currentStore' comes from an index signat... Remove this comment to see the full error message
    return store.currentStore;
  }

  // @ts-expect-error TS(6133): 'catalogNumber' is declared but its value is never... Remove this comment to see the full error message
  function catalogNumber() {
    // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
    return store.catalogNumber;
  }

  function isSpangle() {
    // @ts-expect-error TS(4111): Property 'isSpangle' comes from an index signature... Remove this comment to see the full error message
    return store.isSpangle;
  }

  function removeBgLoading() {
    // @ts-expect-error TS(4111): Property 'removeBgLoading' comes from an index sig... Remove this comment to see the full error message
    return store.removeBgLoading;
  }

  function spangleSizeEditing() {
    // @ts-expect-error TS(4111): Property 'spangleSizeEditing' comes from an index ... Remove this comment to see the full error message
    return spanglesStore.spangleSizeEditing;
  }

  function spanglesLoading() {
    // @ts-expect-error TS(4111): Property 'spanglesLoading' comes from an index sig... Remove this comment to see the full error message
    return spanglesStore.spanglesLoading;
  }

  function spangleSizeEdited() {
    // @ts-expect-error TS(4111): Property 'spangleSizeEdited' comes from an index s... Remove this comment to see the full error message
    return spanglesStore.spangleSizeEdited;
  }

  function invalidSpangleSelected() {
    // @ts-expect-error TS(4111): Property 'invalidSpangleSelected' comes from an in... Remove this comment to see the full error message
    return spanglesStore.invalidSpangleSelected;
  }

  function allAPIsCompleted() {
    // @ts-expect-error TS(4111): Property 'allAPIsCompleted' comes from an index si... Remove this comment to see the full error message
    return spanglesStore.allAPIsCompleted;
  }

  function backgroundProcessesLoading() {
    return removeBgLoading();
  }

  function disableOrderButton() {
    if (backgroundProcessesLoading()) {
      return true;
    }
    if (isSpangle()) {
      return (
        !isReadyForOrder() ||
        spangleSizeEditing() ||
        spanglesLoading() ||
        !allAPIsCompleted() ||
        !spangleSizeEdited() ||
        invalidSpangleSelected()
      );
    }
    return !isReadyForOrder();
  }

  function spangleErrorObject() {
    return {
      errorMessage: "Please finish editing the size of the artwork before adding it to cart."
    };
  }

  function submitForm(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.submitForm(...args);
  }

  function onMousedown() {
    submittedOnMousedown.current = false;
    submitForm();
    submittedOnMousedown.current = true;
  }

  function onClick() {
    if (submittedOnMousedown.current) {
      submittedOnMousedown.current = false;
      return;
    }
    submitForm();
  }

  const prevDisabledRef = useRef(disableOrderButton());
  useEffect(() => {
    const disabled = disableOrderButton();
    if (prevDisabledRef.current && !disabled) {
      submitDtfEvent("add_to_cart_button_enabled", {});
    }
    if (disabled) {
      submittedOnMousedown.current = false;
    }
    prevDisabledRef.current = disabled;
  }, [disableOrderButton()]);

  return (
    // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
    <div {...restProps} className={cn("dtf-add-to-cart scope-c944b75f", restProps?.className)}>
      <div className="dtf-add-to-cart__submit-wrap scope-c944b75f">
        <button
          className="dtf-add-to-cart__button scope-c944b75f"
          type="button"
          // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'boolean ... Remove this comment to see the full error message
          disabled={disableOrderButton()}
          data-testid="dtf-add-to-cart-button"
          onMouseDown={e => {
            if (e.button !== 0) return;
            onMousedown();
          }}
          onClick={onClick}
        >
          {" "}
          Add To Cart{" "}
        </button>
      </div>
      {spangleSizeEditing() ? (
        <ArtworkError
          className="scope-c944b75f"
          // @ts-expect-error TS(2322): Type '{ errorMessage: string; }' is not assignable... Remove this comment to see the full error message
          artwork={spangleErrorObject()}
          data-testid="artwork-error"
        />
      ) : null}
    </div>
  );
}
